<template>
  <div class="list">
    <div class="head">
      <div class="back-wrapper" @click="goBack">
        <svg-icon iconClass="back1" class="back-icon"></svg-icon>
      </div>
      <div class="head-text">常见问题</div>
    </div>
    <div class="content">
      <div class="content-list">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="item-head">
            <div class="icon"></div>
            <div class="text">{{ item.title }}</div>
          </div>
          <div class="item-content">
            <div class="text" v-for="(v, k) in item.textList" :key="k">
              {{ v }}
            </div>
            <div class="teacher-wrapper" v-if="index === 8">
              <div class="teacher"></div>
              <div class="teacher-tips">辅导老师微信二维码</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "course-detail-list",
  created () { },
  data () {
    return {
      list: [
        {
          title: "积木AI课的课程体系是怎样的？",
          textList: [
            "课程体现围绕着6大模块知识，分为L1 、L2 、L3 、L4四个级别，分别培养小朋友的8大能力、15种思维方法。知识内容涵盖但不限于小学校内知识体系。"
          ]
        },
        {
          title: "积木AI课上课流程介绍？",
          textList: [
            "第一步：下载积木思维APP，登录购买课程的账号（手机号）。",
            "第二步： 点击APP首页出现的课程。",
            "开课后，系统每天0点解锁当天的课程，点击已经解锁的课程完成下载，开始上课，完成每天的课程的4个环节约需要15分钟左右。"
          ]
        },
        {
          title: "积木AI课堂环节设置？",
          textList: [
            "我们的课堂是思维启蒙AI双师课，课堂分为四个环节：",
            "1、互动学一学（兴趣唤醒，知识输入）",
            "2、思维大闯关（双向正反馈，帮助小朋友及时巩固知识，获得成就感）",
            "3、我是小老师（开放式环节，引导小朋友知识输出，开阔思路）",
            "4、学习园地（AI实时跟踪，反馈小朋友整体学习情况）"
          ]
        },
        {
          title: "课程如何收费？",
          textList: [
            "目前分为季度课和年课两种。其中季度课金额是480元，包含AI动画课48节，互动直播课3节，共51节。年课金额1920元，包含AI动画课192节，互动直播课12节，共204节。"
          ]
        },
        {
          title: "课程可以保留多久，以后还可以看吗？",
          textList: [
            "积木AI课所有课程都支持无限回放，孩子随时随地都可以回放观看巩固复习，帮助小朋友温故而知新~"
          ]
        },
        {
          title: "积木币的用途？",
          textList: [
            "孩子在学习过程中通过自己的努力得到积木币可以在积木礼品中兑换礼物，兑换成功后，我们会按照您填写的地址免费给孩子邮寄过去哦~"
          ]
        },
        {
          title: "积木AI课支持调级别吗？",
          textList: ["您好，现在积木AI课暂不支持级别调整。~~"]
        },
        {
          title: "可以再电脑上上课吗？",
          textList: ["暂不支持电脑上课。目前支持安卓、苹果ios下载的手机端和平板电脑端APP中上课。"]
        },
        {
          title: "如何添加辅导老师微信？",
          textList: [
            "完成付费后请您按照系统提示主动添加辅导老师微信，开课前48小时如您未添加，辅导老师将与您取得联系（微信添加或电话沟通）"
          ]
        },
        {
          title: "积木思维课退费规则？",
          textList: [
            "【积木思维系统课】系统课随时可线下退费，未解锁课程按整周退费结算。扣除已解锁学费，扣除大礼包/随材费用，随材不需寄回。购买后配套教材未寄出的情况下，不扣教材费可退课；已寄出或已到货的情况下退课，扣除教材费，不需要寄回到仓库。 ",
            "退费金额=订单实付金额-课时费用*需要扣款课时－赠品成本。",
            "课时费用=订单实付金额/订单课时",
            "需要扣款课时=订单课时-退费课时",
            "【精选教具大礼包】120/个"
          ]
        },
        {
          title: "上课时碰到黑屏卡顿等问题怎么办？",
          textList: [
            "如果碰到以上情况，可能是由于“网络异常”引起，需要您退出APP重新登录即可。退出方法：app-我的-点击退出登录。"
          ]
        },
        {
          title: "辅导老师资质？",
          textList: [
            "您好，我们的辅导老师是从8个点进行选拔，12个点考核，每月每季度进行教研培训。确保每次课，每章节课，每单元课班主任老师都会帮小朋友深度解读所学知识，给到最贴心，最专业的辅导。"
          ]
        },
        {
          title: "怎么购买课程？",
          textList: [
            "我们的应用程序中，用户如果想购买app里面的课程，需要关注积木AI课微信公众号，进行线下报名课程购买。"
          ]
        }
      ]
    }
  },
  methods: {
    goBack () {
      if (!navigator.onLine) {
        this.$router.push({ name: "Refresh" })
        return
      }
      this.$bridge.callHandler("goBack", {}, () => { })
    }
  }
};
</script>
<style lang="less" scoped>
.list {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 100;
  overflow: hidden;
  overflow-y: auto;
  background: #f4f4f4;

  .head {
    display: flex;
    align-items: center;
    position: fixed;
    width: 100%;
    height: 100px;
    background: #fff;

    .back-wrapper {
      position: absolute;
      left: 0px;
      top: 0px;
      height: 100px;
      width: 100px;
      padding-left: 30px;
      display: flex;
      align-items: center;

      .back-icon {
        width: 34px;
        height: 34px;
      }
    }

    .head-text {
      flex: 1;
      text-align: center;
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1d1d1d;
      line-height: 48px;
    }
  }

  .content {
    padding-top: 100px;

    .content-list {
      padding: 0 30px 70px 30px;

      .item {
        margin-top: 30px;
        border-radius: 8px;
        background: #fff;

        .item-head {
          display: flex;
          align-items: center;
          padding: 30px 0 30px 24px;
          border-bottom: 1px dotted #dddddd;

          .icon {
            width: 42px;
            height: 42px;
            margin-right: 22px;
            background: url("./icon.png") no-repeat;
            background-size: cover;
          }

          .text {
            font-size: 30px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #222222;
            line-height: 42px;
          }
        }

        .item-content {
          padding: 28px 24px;

          .text {
            text-align: justify;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 40px;
          }
          .text + .text {
            margin-top: 20px;
          }
          .teacher-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 30px;
            .teacher {
              width: 282px;
              height: 282px;
              background: url("./teacher.jpeg") no-repeat;
              background-size: cover;
            }
            .teacher-tips {
              margin-top: 10px;
              font-size: 28px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 40px;
            }
          }
        }
      }
    }
  }
}
</style>
